import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { exportVaultSecrets, getExportVaultSecretsMutationOptions, type Vault } from '@/modules/api/codegen';
import { actions as messagesActions } from '@/modules/messages';

import { vaultExportFileName } from '../utils';

const CSV_MIME = 'text/csv';

// Takes the whole vault because the file is named after it. Mutations bypass the shared query cache's
// `onError`, so the failure is reported here; the download itself is the success feedback.
export const useExportVault = () => {
    const dispatch = useDispatch();

    return useMutation({
        mutationKey: getExportVaultSecretsMutationOptions().mutationKey,
        mutationFn: async (vault: Vault) => {
            const { data } = await exportVaultSecrets({ vaultId: vault.id }, { responseDataType: 'blob', headers: { accept: CSV_MIME } });
            const { default: downloadFile } = await import('js-file-download');

            downloadFile(data, vaultExportFileName(vault.name), CSV_MIME);
        },
        onError: () =>
            dispatch(
                messagesActions.displayErrorMessage({
                    message: { id: 'vaults.actions.export.error' },
                    options: { duration: 5 },
                }),
            ),
    });
};
